// src/pages/gt3x/Streamer.jsx
import { useEffect, useMemo, useState } from "react";
import { fetchSheetViaProxy } from "../../lib/sheets";

// Tab in Google Sheets: "Streamers"
// Spalte A = Fahrer, Spalte B = Link
const RANGE = "Streamers!A1:B500";

function asLink(value) {
    if (value == null) return "";
    const str = String(value).trim();
    if (!str) return "";

    // wenn es wie eine URL aussieht -> klickbar machen
    if (/^https?:\/\//i.test(str)) {
        return (
            <a className="link-accent" href={str} target="_blank" rel="noreferrer">
                {str}
            </a>
        );
    }

    // wenn jemand ohne https:// einträgt (z.B. twitch.tv/xyz) -> trotzdem klickbar
    if (/^(twitch\.tv\/|youtube\.com\/|youtu\.be\/)/i.test(str)) {
        const url = `https://${str.replace(/^https?:\/\//i, "")}`;
        return (
            <a className="link-accent" href={url} target="_blank" rel="noreferrer">
                {str}
            </a>
        );
    }

    return str;
}

export default function Streamer() {
    const [data, setData] = useState({ header: [], rows: [] });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        (async () => {
            try {
                const res = await fetchSheetViaProxy({ range: RANGE });
                setData(res);
            } catch (e) {
                setError(e?.message || "Fehler beim Laden der Streamer-Daten.");
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    const rows = useMemo(() => {
        const headers = data.header || [];
        const rowsObj = data.rows || [];

        // zu Array [fahrer, link]
        const arr = rowsObj.map((r) => [r[headers[0]], r[headers[1]]]);

        // Header-Zeile rausfiltern + leere Zeilen raus
        return arr
            .filter(([fahrer, link]) => {
                const f = String(fahrer ?? "").trim();
                const l = String(link ?? "").trim();
                if (!f && !l) return false;
                if (f.toLowerCase() === "fahrer" && l.toLowerCase() === "link") return false;
                return true;
            });
    }, [data]);

    return (
        <>
            <div className="card overview-card">
                <h2>Streamer</h2>
                <p className="muted">
                    Hier findest du die Stream-Links aller Fahrer.
                </p>
            </div>

            {loading && (
                <div className="card overview-card">
                    <p>Lade Streamer-Liste …</p>
                </div>
            )}

            {!loading && error && (
                <div className="card overview-card">
                    <p className="muted" style={{ color: "#f55" }}>{error}</p>
                </div>
            )}

            {!loading && !error && (
                <div className="card overview-card">
                    <div className="fancyTable">
                        <table className="tbl tbl-overview-table overview-table">
                            <thead>
                            <tr>
                                <th className="align-left">Fahrer</th>
                                <th className="align-left">Link</th>
                            </tr>
                            </thead>
                            <tbody>
                            {rows.length === 0 ? (
                                <tr>
                                    <td className="align-left" colSpan={2}>
                                        Noch keine Streamer eingetragen.
                                    </td>
                                </tr>
                            ) : (
                                rows.map(([fahrer, link], idx) => (
                                    <tr key={idx}>
                                        <td className="align-left">{fahrer}</td>
                                        <td className="align-left">{asLink(link)}</td>
                                    </tr>
                                ))
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </>
    );
}
